import React, { PureComponent } from 'react';
import {IUsersSearchBarProps} from "./models";
import {Button} from "react-bootstrap";

interface IUsersSearchBarState {
    searchQuery: string;
}

export class UsersSearchBar extends PureComponent<IUsersSearchBarProps, IUsersSearchBarState> {

    state = {
        searchQuery: "",
    };

    onInputChange = (inputEvent: React.ChangeEvent<HTMLInputElement>) => {
        const searchQuery = inputEvent.target.value;
        this.setState({searchQuery});
        this.props.onFilter({searchQuery});
    };

    render() {

        return (
            <div className="bar-position">
                <h2 className='text-light'>
                    Kasutajad
                </h2>
                <div className="card mb-5 shadow">
                    <div className="card-body">
                        <div className="d-flex flex-wrap flex-sm-nowrap">
                            <input
                                placeholder="Nimi"
                                className='search-bar__input'
                                onChange={this.onInputChange}
                                value={this.state.searchQuery}
                            />
                            <Button className="ml-auto d-flex align-items-center"
                                    onClick={() => this.props.openAddUsersModal()}
                                    variant={"primary"}>
                                <i className="icon--16 icon__add d-flex mr-1"/>
                                <span>Lisa kasutajaid</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}